import { config } from "../../utils/constants";
import { getCurrentLocale } from "../../utils/util";
import { oAuthRequest } from "../../utils/request";
export const getAllDetails = (requestData) => {
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.paymentReconcilliationServices}getAllDetails`,
    method: 'post',
    data: {
      servCode: requestData.servCode,
      sptrn: requestData.sptrn,
      returnDEGTRN: requestData.degtrn,
      paymentType: requestData.paymentMethod,
      paymentStatus: requestData.status,
      from: requestData.fromDate,
      to: requestData.toDate,
      ...(requestData.page != null && { page: requestData.page }),
      ...(requestData.pageSize != null && { pageSize: requestData.pageSize }),
    }
  };
  return oAuthRequest(requestConfig);
};
export const getPicklist = () => {
  const locale = getCurrentLocale();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.paymentReconcilliationServices}getPicklist/${locale}`,
    method: "get"
  };
  return oAuthRequest(requestConfig);
};

